<template>
	<div class="rewards-grid-container">




		<Reward-Tile v-for="(option, key) in payoutOptions" :key="key" @click="handleTileClick(option)" :imageUrl="option.option.icon">

			<template v-slot:payout-name>
				<div class="ellipsis d-flex justify-center">{{ option.option.name }}</div>
			</template>

		</Reward-Tile>





	</div>
</template>



<script setup lang="ts">

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { PayoutStore } from '@/store/PayoutStore';
import RewardTile from '@/components/Tiles/Rewards/Reward-Tile.vue';
import { PayoutOptionDenominations } from '@/interfaces/Payouts/PayoutOptionDenominations'

const router = useRouter();
const payoutStore = PayoutStore();
const payoutOptions = computed(() => payoutStore.PayoutOptionsAndTheirDenominations);

const handleTileClick = (option: PayoutOptionDenominations) => {
	if (option.option.name.toLowerCase().includes('paypal')) {
		router.push(`/reward/paypal/${option.option.id}`);
	} else {
		router.push(`/reward/${option.option.id}`);
	}
	payoutStore.setSelectedPayoutOption(option.option.id);
};

</script>




<style scoped lang="scss">
.rewards-grid-container {} // TODO: Removing this class remove the rounded corners from the tiles
</style>